const { registerPaymentMethod } = wc.wcBlocksRegistry;
const { decodeEntities } = wp.htmlEntities;
const { getSetting } = wc.wcSettings;
const { createElement, useEffect, useCallback, useRef } = wp.element;
const { select, dispatch } = wp.data;
console.log(wc);
const CardFields = ({eventRegistration, emitResponse}) => {
    const activePaymentMethod = select('wc/store/checkout').getActivePaymentMethod;
    const { onPaymentSetup } = eventRegistration;
    const cardNumberRef = useRef(null);
    const cardExpiryRef = useRef(null);
    const cardCvcRef = useRef(null);

    const validateCard = useCallback(() => {
        const errors = [];
        const cardData = {
            number: cardNumberRef.current?.value.replace(/\s/g, '') || '',
            expiry: cardExpiryRef.current?.value.replace(/\s/g, '') || '',
            cvc: cardCvcRef.current?.value.replace(/\s/g, '') || ''
        };

        if (!/^\d{16}$/.test(cardData.number)) {
            errors.push('Card number is invalid.');
        }

        if (!/^\d{2}\/\d{2}$/.test(cardData.expiry)) {
            errors.push('Expiry date is invalid.');
        }

        if (!/^\d{3,4}$/.test(cardData.cvc)) {
            errors.push('CVC is invalid.');
        }

        return errors;
    }, []);

        

    // Handle form submission
    useEffect(() => {

        const unsubscribe = onPaymentSetup(async () => {

            if(activePaymentMethod !== 'wbp_card') return;

            const validationErrors = validateCard();

            if(validationErrors.length > 0) {
                return {
                    type: emitResponse.resposeType.ERROR,
                    message: validationErrors.join(' '),
                    messageContext: emitResponse.noticeContexts.PAYMENTS
                };
            }

            try {
                const paymentResult = await processPayment({
                    number: cardNumberRef.current.value,
                    expiry: cardExpiryRef.current.value,
                    cvc: cardCvcRef.current.value
                });

                return {
                    type: emitResponse.resposeType.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            ...paymentResult,
                            payment_method: 'wbp_card'
                        }
                    }
                };
            } catch (error) {
                return {
                    type: emitResponse.resposeType.ERROR,
                    message: error.message,
                    messageContext: emitResponse.noticeContexts.PAYMENTS
                };
            }

        });

        return unsubscribe;
    }, [validateCard, activePaymentMethod, onPaymentSetup, emitResponse]);

    return createElement('div', { className: 'wc-block-components-card-fields' },
        createElement('div', { className: 'wc-block-components-text-input' },
            createElement('input', {
                type: 'tel',
                ref: cardNumberRef,
                placeholder: '•••• •••• •••• ••••',
                autoComplete: 'cc-number',
                id: 'wbp-card-number',
                name: 'card-number'
            })
        ),
        createElement('div', { className: 'wc-block-components-card-fields__row' },
            createElement('div', { className: 'wc-block-components-text-input' },
                createElement('input', {
                    type: 'tel',
                    ref: cardExpiryRef,
                    placeholder: 'MM / YY',
                    autoComplete: 'cc-exp',
                    id: 'wbp-card-expiry',
                    name: 'card-expiry'
                })
            ),
            createElement('div', { className: 'wc-block-components-text-input' },
                createElement('input', {
                    type: 'tel',
                    ref: cardCvcRef,
                    placeholder: 'CVC',
                    autoComplete: 'cc-csc',
                    id: 'wbp-card-cvc',
                    name: 'card-cvc'
                })
            )
        )
    );
};

registerPaymentMethod({
    name: 'wbp_card',
    label: createElement('div', { className: 'wbp-card-method-label' },
        decodeEntities(wbp_block_data.title),
        wbp_block_data.icon && createElement('img', {
            src: wbp_block_data.icon,
            alt: decodeEntities(wbp_block_data.title),
            className: 'wbp-card-method-icon'
        })
    ),
    ariaLabel: 'Credit/Debit Card payment method',
    content: createElement(CardFields, {
        eventRegistration: wc.wcBlocksRegistry.eventRegistration,
        emitResponse: wc.wcBlocksRegistry.emitResponse
    }),
    edit: createElement(CardFields, {
        eventRegistration: wc.wcBlocksRegistry.eventRegistration,
        emitResponse: wc.wcBlocksRegistry.emitResponse
    }),
    canMakePayment: () => true,
    supports: {
        features: wbp_block_data.supports || ['products'],
    },
    paymentMethodId: 'wbp_card'
});

async function processPayment(cardData) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (Math.random() < 0.95) {
                resolve({
                    transaction_id: `txn_${Date.now()}`,
                    payment_status: 'success'
                });
            } else {
                reject(new Error('Payment failed'));
            }
        }, 1500);
    });
}